// extracted by mini-css-extract-plugin
export default {"unFocusComponent":"SearchResourceInput_unFocusComponent__0eNeR","code":"SearchResourceInput_code__dd3UH","text":"SearchResourceInput_text__4LmVC"};